import { Number, Record, Static, String } from 'runtypes'

export const Suggestion = Record({
    id: Number.Or(String),
    suggestionTypeId: Number,
    title: String,
    suggestionTypeTitle: String,
    sortOrder: Number
})
export type ISuggestion = Static<typeof Suggestion>
